/*eslint-disable*/
import React, { useState, useEffect } from "react";
import {
    Card,
    CardBody,
    Label,
    FormGroup,
    Row,
    Input,
    CardHeader,
    Col,
    Button,
    Container
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"
import CurrencyInput from 'react-currency-input-field';

export default function EditKasbon(props) {
    const [alert, setAlert] = React.useState(null);
    const token = localStorage.token;
    let history = useHistory();
    const warehouseId = localStorage.warehouse;
    // const username = localStorage.username;
    const [description, setDescription] = useState("");
    const [judul, setJudul] = useState("");
    const [nominal, setNominal] = useState(0)
    const [isSpinner, setIsSpinner] = useState(false);
    const [tenor, setTenor] = useState("")

    const handleSubmit = () => {
        setTimeout(() => { UpdateKasbon() }, 2000);
        setIsSpinner(true);
    };

    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/cash-bon/get/${props.match.params.id}`, { headers })
            .then((data) => {
                const res = data.data.response;
                setJudul(data.data.response.judul);
                setNominal(data.data.response.nominal_request);
                setDescription(data.data.response.keterangan);
                setTenor(data.data.response.tenor)
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const UpdateKasbon = () => {
        const headers = {
            Authorization: `Bearer ${token}`,
        };
        let data = {
            judul: judul,
            nominal_request: nominal,
            warehouse_id: parseInt(warehouseId),
            keterangan: description
        };
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/cash-bon/update/${props.match.params.id}`, data, { headers })
            .then(function (response) {
                setSuccessAlert(response.data.message);
                setIsSpinner(false);
                // setTimeout(() => (history.push("/mobile/dispensasi-karyawan/izin")), 1000);
                history.push("/mobile/kasbon/sukses")

            })
            .catch(function (error) {
                setGagalAlert(error.response.data.message);
                setIsSpinner(false);

            });
    }

    const setSuccessAlert = (id) => {
        setAlert(
            <SweetAlert
                success
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        )
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const setQuestionAlert = () => {
        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Lanjutkan"
                confirmBtnBsStyle="danger"
                title="Apakah Kamu Yakin?"
                onConfirm={handleSubmit}
                onCancel={hideAlert}
                focusCancelBtn
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const Nominal = (e) => {
        const value = e === undefined ? 'undefined' : e;
        setNominal(value || ' ');
    };

    return (
        <>
            {alert}
            {/* <SimpleHeader name="Buat Izin" parentName="Master" /> */}
            {isSpinner ? (
                <Container className="mt--10 pb-10 login-container">
                    <Row className="justify-content-center">
                        <Col lg="5" md="7">
                            <div className="d-flex flex-column align-items-center d-lg-none d-xl-none">
                                <img src={require("assets/img/theme/loadingmobile1.gif").default} style={{ textAlign: "center", height: "12rem", width: "12rem", paddingTop: "1rem" }} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <>
                    <SimpleHeaderMobile to="/mobile/kasbon/page" />
                    <Container className="mt--6" fluid>
                        <Row>
                            <div className="col">
                                {/* <CardBody> */}
                                <Row md="12">
                                    <Col md="12">
                                        <Card className="bg-secondary shadow">
                                            <CardHeader className="bg-white border-0">
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <h2>Update Pinjaman</h2>
                                                    <div style={{ textAlign: 'left' }} className="d-lg-block d-none">
                                                        <Link className="btn btn-link" to="/mobile/kasbon/page">
                                                            <i className="fa fa-arrow-circle-left fa-2x" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Judul</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                        name="deskripsi Item"
                                                        placeholder="Masukan Judul"
                                                        value={judul}
                                                        onChange={(e) => {
                                                            setJudul(e.target.value);
                                                        }}
                                                    />
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Nominal</Label>

                                                    <CurrencyInput
                                                        id="validation-example-2-field"
                                                        placeholder="Rp0"
                                                        value={nominal}
                                                        onValueChange={Nominal}
                                                        className={`form-control`}
                                                        prefix={'Rp'}
                                                        step={10}
                                                    />

                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Tenor</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="select"
                                                        value={tenor}
                                                        onChange={(e) => {
                                                            setTenor(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">Pilih Tenor</option>
                                                        <option value="1">1 Bulan</option>
                                                        <option value="2">2 Bulan</option>
                                                    </Input>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Keterangan</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        rows="7"
                                                        type="textarea"
                                                        name="deskripsi Item"
                                                        placeholder="Masukan Keterangan"
                                                        value={description}
                                                        onChange={(e) => {
                                                            setDescription(e.target.value);
                                                        }}
                                                    />
                                                </FormGroup>
                                            </CardBody>
                                            <Button color="danger" onClick={() => handleSubmit()}>
                                                Simpan
                                            </Button>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                    </Container>
                </>
            )}
        </>
    );
}
